import {useProductOptions} from '@shopify/hydrogen';
import clsx from 'clsx';

//types
import type {
  Maybe,
  Image as ImageProps,
  ProductVariant,
} from '@shopify/hydrogen/storefront-api-types';

interface ColourOptionsWithThumbnail {
  colour: string;
  thumbnail: Maybe<ImageProps> | undefined;
  available?: boolean;
  sizes?: {size: string | undefined; available: boolean}[];
}

export default function ProductDetailsOptionSize({
  name,
  values,
  allColourOptionsWithThumbnail,
  allVariants,
}: {
  name: string;
  values: string[];
  allColourOptionsWithThumbnail?: ColourOptionsWithThumbnail[] | undefined;
  allVariants: ProductVariant[];
}) {
  const {setSelectedOption, selectedOptions} = useProductOptions();

  const selectedColour = allColourOptionsWithThumbnail?.find(
    (v) => v.colour === selectedOptions?.Colour || v.colour === selectedOptions?.Color,
  );

  const handleChange = (optionName: string, optionValue: string) => {
    if (setSelectedOption) {
      setSelectedOption(optionName, optionValue);
    }
  };

  return (
    <fieldset key={name} className="my-2">
      {/* Name */}
      <ul className="grid grid-cols-6 gap-2">
        {values.map((value, index) => {
          const checked = selectedOptions?.[name] === value;
          const sizeInColour = selectedColour?.sizes?.find(
            (s) => s.size === value,
          );
          const size =
            !selectedColour && allVariants.find((v) => v.title === value);
          const id = `option-${name}-${value}`;
          return (
            <li
              key={`${id}-${index}`}
              className={clsx([
                'product-variant--size',
                selectedColour && sizeInColour?.available
                  ? ''
                  : size && size.availableForSale
                  ? ''
                  : 'pointer-events-none opacity-25',
              ])}
            >
              <label key={id} htmlFor={id}>
                <input
                  className="sr-only"
                  type="radio"
                  id={id}
                  name={`option[${name}]`}
                  value={value}
                  checked={checked}
                  onChange={() => handleChange(name, value)}
                  placeholder={name}
                />
                <div
                  className={clsx([
                    'flex justify-center min-h-[38px] min-w-[30px] cursor-pointer items-center rounded-[6px] bg-black p-2 text-center text-[20px] leading-none',
                    (selectedColour && sizeInColour?.available && checked) ||
                    (size && size.availableForSale && checked)
                      ? 'text-hk-orange'
                      : 'text-white',
                  ])}
                >
                  <span className="">{value}</span>
                </div>
              </label>
            </li>
          );
        })}
      </ul>
    </fieldset>
  );
}
